import { getSessionDateGroupKey } from "util/copilotSessionGroups";

const GROUP_KEYS = {
  today: "sonic_prospect.history_group_today",
  yesterday: "sonic_prospect.history_group_yesterday",
  last_week: "sonic_prospect.history_group_last_week",
  older: "sonic_prospect.history_group_older",
};

export function formatLastChat(ts, t, locale, now = Date.now()) {
  if (!ts) {
    return {
      time: "—",
      day: t("sonic_prospect.last_chat_none", "No chats yet"),
    };
  }
  const date = new Date(ts);
  const time = date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
  const group = getSessionDateGroupKey(ts, now);
  if (group === "today" || group === "yesterday") {
    return { time, day: t(GROUP_KEYS[group]) };
  }
  return {
    time,
    day: date.toLocaleDateString(locale, { day: "numeric", month: "short" }),
  };
}
